import React from "react";
import _ from "lodash";
import "../style/pagination.css";
import { useState, useEffect } from "react";

function Pagination(props) {
  const [isThereAnyNext, setIsThereAnyNext] = useState(false);
  const [isThereAnyBefore, setIsThereAnyBefore] = useState(false);
  const pageCount = Math.ceil(props.countOfItems / props.pageSize);
  if (pageCount === 1) return null;
  const pages = _.range(1, pageCount + 1);

  const handle = (p) => {
    let a = 0;
    let b = 0;

    if (props.currentPage === 1) a = 2;
    if (props.currentPage === 2) a = 1;
    if (props.currentPage === pageCount - 1) b = 1;
    if (props.currentPage === pageCount) b = 2;

    if (p <= props.currentPage + a + 2 && p >= props.currentPage - b - 2) {
      return (
        <li
          key={p}
          className={
            p === props.currentPage
              ? "page-item choosen"
              : "page-item not-choosen"
          }
        >
          <a
            className={
              p === props.currentPage
                ? "page-link choosen"
                : "page-link not-choosen"
            }
            onClick={() => props.onPageClicked(p)}
          >
            {p}
          </a>
        </li>
      );
    } else if (p > props.currentPage + 2) {
      return;
    } else {
      return;
    }
  };
  return (
    <div className="pagination-container">
      {props.currentPage > 1 && (
        <img
          className="icon left-arrow"
          onClick={() => props.onPageClicked(props.currentPage - 1)}
          src={require("../assets/previous.png")}
        ></img>
      )}
      <ul className="pagination">{pages.map((p) => handle(p))}</ul>
      {props.currentPage < pageCount && (
        <img
          className="icon right-arrow"
          onClick={() => props.onPageClicked(props.currentPage + 1)}
          src={require("../assets/next.png")}
        ></img>
      )}
    </div>
  );
}

export default Pagination;
